import React, { useState } from "react";
import CarBlogSection from "./CarBlogSection";
import "../style/TabsDashboard.css";

const CarNewsTabs = () => {
  const [activeTab, setActiveTab] = useState("Cars");

  const tabs = ["Cars", "Recent Posts", "Related Articles", "Latest News"];

  const renderContent = () => {
    switch (activeTab) {
      case "Cars":
      case "Recent Posts":
        return <CarBlogSection />;
      default:
        return <div className="coming-soon">More updates arriving shortly.</div>;
    }
  };

  return (
    <div id="news" className="premium-news-container">
      <div className="news-header-flex">
        <h2 className="news-minimal-title">
          Cars <span>News</span>
        </h2>
        
        <nav className="tab-nav">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </nav>
      </div>

      <div className="tab-pane">
        {renderContent()}
      </div>
    </div>
  );
};

export default CarNewsTabs;